<div class="progress-spinner" *ngIf="spinnerService._loading$ | async">
    <p-progressSpinner></p-progressSpinner>
</div>
<p-toast></p-toast>
<router-outlet></router-outlet>
